import React, {PropTypes} from 'react';
import { Link, IndexLink } from 'react-router';

const Header = ({loading, user, collection, recipe, recipes, navClass, toggleNav, onSignOut}) => { //, pathName
	let statusIndicator = "Logged Out";
	let logoClass = "";

	//determine login status for header
	let loggedIn = false;
	if (user.length != 0) { //check for undefined - data inside "user" is undefined in state until reducer finishes, but page loads before reducer finishers, and updates again once it's done
		if (user[0].id != 0) {
			statusIndicator = "User ID: " + user[0].id;
			logoClass="logged-in";
			loggedIn = true;
		}
	}

	//determine is this is a collection page (to display filter icon)
	// let collectionPage = false;
	// if (pathName == '/browse' || pathName == '/') {
	// 	collectionPage = true;
	// }

	//debugging panel
	let currentCollectionTitle = "";
	let currentCollectionList = "";
	let currentRecipeTitle = "";
	if (collection.length != 0) {
		currentCollectionTitle = " - Current Collection: (" + collection[0].id + ") " + collection[0].name + " (" + collection[0].recipes.length + " Recipes)";
	}
	if (recipe.length != 0) {
		currentRecipeTitle = " - Current Recipe: " + recipe[0].title;
	}
	if (recipes.length != 0) {
		recipes.map(function(thisRecipe) {
			if (recipe.length != 0 && thisRecipe.id == recipe[0].id) {
				currentCollectionList += thisRecipe.id + '*,';
			} else {
				currentCollectionList += thisRecipe.id + ',';
			}
		});
		currentCollectionList = currentCollectionList.substring(0, currentCollectionList.length - 1);
	}

	//background images
	let searchImageLime = require('../../images/ui-search-lime.png');
	let menuToggle = require('../../images/ui-menu.png');	
	let menuClose = require('../../images/ui-close-rose.png');	

	return (
		<div className="header-container">
			<div className="header-padding">
				<IndexLink to="/" className={"logo " + logoClass}><img src={require('../../images/logo.png')} /></IndexLink>
				{!loggedIn && <Link to="/signup" className="menu-signup">Sign Up</Link>}
				{!loggedIn && <Link to="/login" className="menu-login">Log In</Link>}
				<div className="header-debug">
					{statusIndicator}
					{currentCollectionTitle}
					{currentRecipeTitle}<br />
					{currentCollectionList}
					{loading && <img src={require('../../images/ellipsis.gif')} width="70" height="35" />}
				</div>
			</div>
		</div>
	); //{collectionPage && <a href="#" className="menu-filter" style={{backgroundImage: `url(${searchImageLime})`}}>Filter</a>}
			
};

Header.propTypes = {
	user: PropTypes.array.isRequired,
	collection: PropTypes.array.isRequired,
	recipe: PropTypes.array.isRequired,
	recipes: PropTypes.array.isRequired,
	loading: PropTypes.bool.isRequired,
	navClass: PropTypes.string.isRequired,
	toggleNav: PropTypes.func.isRequired,
	onSignOut: PropTypes.func.isRequired
}; //pathName: PropTypes.string.isRequired

export default Header;


/** WEBPACK FOOTER **
 ** ./src/components/common/Header.js
 **/